import styled from 'styled-components';
import { colors, font, space } from 'nicollet-tokens';
import { ndsFontReset } from '@nicollet/common';

const validStyles = `color: ${colors.palette.green.default};`;
const invalidStyles = `
  &:after {
    content: '';
    background: ${colors.palette.orange.light};
    position: fixed;
    top: 50%;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: -1;
  }
  color: ${colors.palette.orange.dark};
`;
const Superscript = styled.div`
  ${ndsFontReset()}
  color: ${colors.text.formLabel};
  font-size: ${font.size.text.small};
  position: absolute;
  transform: translate3d(0, -8px, 0);
  background-color: ${props => props.disabled ? colors.background.disabled : colors.background.default};
  padding: 0 ${space.generic.x1};
  backface-visibility: hidden;
  margin-left: ${space.generic.x2};
  z-index: 1;
  pointer-events: none;
  ${props => props.valid && validStyles};
  ${props => props.invalid && invalidStyles};
`;

export { Superscript };
